<template>
  <div class="game-container">
    <div id="game-container"><canvas id="gameCanvas"></canvas></div>
  </div>
</template>

<script>
import _ from 'lodash';
import createjs from 'createjs-collection';
import preload from 'preload-js';
export default {
  name: 'mp-dnd-free-v2',
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      initData: {},
      stage: null,
      width: 0,
      height: 0,
      offset: {},
      images: [],
      containers: [],
      moved: 0,
    };
  },
  beforeMount() {},
  mounted() {
    //  this.initData = _.cloneDeep(this.startGameConfig);
    this.stage = new createjs.Stage('gameCanvas');
    this.stage.mouseMoveOutside = true;
    this.stage.snapToPixelEnabled = true;
    this.setStage();
    createjs.Touch.enable(this.stage);
    // console.log(createjs.Touch.isSupported());
  },
  created() {},
  methods: {
    setStage() {
      this.initData = _.cloneDeep(this.startGameConfig);
      this.width = this.initData.width ? this.initData.width : document.getElementById('game-container').offsetWidth;
      this.height = this.initData.height
        ? this.initData.height
        : document.getElementById('game-container').offsetHeight;
      this.stage.canvas.width = this.width;
      this.stage.canvas.height = this.height;
      this.offset = {
        x: this.stage.canvas.width / 2,
        y: this.stage.canvas.height / 2,
      };
      this.stage.x = this.offset.x;
      this.stage.y = this.offset.y;
      for (let i = 0; i < this.initData.targets.length; i++) {
        let target = this.initData.targets[i];
        let container = new createjs.Container();
        container.name = target.id;
        if (target.bgr.split('/').length == 1) {
          let shape = new createjs.Shape();
          container.width = shape.width = Number.isInteger(target.pos.w) ? target.pos.w : this.width;
          container.height = shape.height = Number.isInteger(target.pos.h) ? target.pos.h : this.height;
          if (target.border) {
            shape.graphics.ss(1).s(target.border);
          }
          shape.graphics.f(target.bgr).dr(0, 0, shape.width, shape.height).ef();
          shape.id = target.id;
          container.x =
            (Number.isInteger(target.pos.x) ? target.pos.x : (this.width - shape.width) / 2) - this.offset.x;
          container.y =
            (Number.isInteger(target.pos.y) ? target.pos.y : (this.height - shape.height) / 2) - this.offset.y;
          container.addChild(shape);
          container.cache(0, 0, container.width, container.height);
          this.stage.addChild(container);
        } else {
          let queue = new preload.LoadQueue();
          var self = this;
          container.x = (Number.isInteger(target.pos.x) ? target.pos.x : 0) - this.offset.x;
          container.y = (Number.isInteger(target.pos.y) ? target.pos.y : 0) - this.offset.y;
          queue.on('fileload', function (e) {
            let bmp = new createjs.Bitmap(e.result.src);
            bmp.id = e.item.id;
            e.item.cont.width = e.result.width;
            e.item.cont.height = e.result.height;
            e.item.cont.addChild(bmp);
            e.item.cont.cache(0, 0, e.item.cont.width, e.item.cont.height);
          });
          queue.on('complete', function (e) {
            self.stage.update();
          });
          queue.loadManifest([{ cont: container, id: target.id, src: target.bgr }]);
        }
        this.stage.addChildAt(container, 0);
        this.containers[container.name] = { id: container.name, cont: container };
      }
      let container = new createjs.Container();
      container.name = 'source';
      if (this.initData.source.bgr.split('/').length == 1) {
        let shape = new createjs.Shape();
        container.width = shape.width = Number.isInteger(this.initData.source.pos.w)
          ? this.initData.source.pos.w
          : this.width;
        container.height = shape.height = Number.isInteger(this.initData.source.pos.h)
          ? this.initData.source.pos.h
          : this.height;
        if (this.initData.source.border) {
          shape.graphics.ss(1).s(this.initData.source.border);
        }
        shape.graphics.f(this.initData.source.bgr).dr(0, 0, shape.width, shape.height).ef();
        shape.id = 'source';
        container.x =
          (Number.isInteger(this.initData.source.pos.x) ? this.initData.source.pos.x : (this.width - shape.width) / 2) -
          this.offset.x;
        container.y =
          (Number.isInteger(this.initData.source.pos.y)
            ? this.initData.source.pos.y
            : (this.height - shape.height) / 2) - this.offset.y;
        container.addChild(shape);
        container.cache(0, 0, container.width, container.height);
        this.stage.addChild(container);
      } else {
        let queue = new preload.LoadQueue();
        var self = this;
        container.x = (Number.isInteger(this.initData.source.pos.x) ? this.initData.source.pos.x : 0) - this.offset.x;
        container.y = (Number.isInteger(this.initData.source.pos.y) ? this.initData.source.pos.y : 0) - this.offset.y;
        queue.on('fileload', function (e) {
          let bmp = new createjs.Bitmap(e.result.src);
          bmp.id = e.item.id;
          e.item.cont.width = e.result.width;
          e.item.cont.height = e.result.height;
          e.item.cont.addChild(bmp);
          e.item.cont.cache(0, 0, e.item.cont.width, e.item.cont.height);
        });
        queue.on('complete', function (e) {
          self.stage.update();
        });
        queue.loadManifest([{ cont: container, id: this.initData.source.id, src: this.initData.source.bgr }]);
      }
      this.stage.addChildAt(container, 0);
      this.containers[container.name] = { id: container.name, cont: container, indx: [] };
      this.loadImages();
      this.stage.update();
    },
    loadImages() {
      var self = this;
      let pick = Number.isInteger(this.initData.pick)
        ? this.initData.pick > this.initData.samples.length
          ? this.initData.samples.length
          : this.initData.pick
        : this.initData.samples.length;
      var indx = [];
      let shuffle = this.initData.shuffle ? true : false;
      if (shuffle) {
        do {
          indx = [];
          for (let i = 0; i < pick; i++) {
            let ix = Math.round(Math.random() * (this.initData.samples.length - 1));
            let flg = false;
            for (let j = 0; j < indx.length; j++) if (indx[j] == ix) flg = true;
            if (flg) i--;
            else indx[i] = ix;
          }
          var ok = 0;
          if (this.initData.corrBlock) {
            var tab = [];
            for (let i = 0; i < this.initData.targets.length; i++) {
              tab = tab.concat(this.initData.targets[i].correct);
            }
            for (let i = 0; i < indx.length; i++) {
              if (tab[i] == this.initData.samples[indx[i]].id) ok++;
            }
          }
        } while (ok == indx.length);
      } else indx = Array.from({ length: pick }, (v, k) => k);
      var images = [];
      indx.forEach(function (ind, i) {
        images[i] = Object.assign({}, self.initData.samples[ind]);
      });
      var manifest = [];
      images.forEach(function (img) {
        manifest.push(img);
      });
      let queue = new preload.LoadQueue();
      queue.on('fileload', function (e) {
        self.handleFileLoad(e);
      });
      queue.on('complete', function (e) {
        self.handleComplete(e);
      });
      queue.loadManifest(manifest);
    },
    shuffle(a) {
      if (a.length == 0) return;
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    newGame() {
      this.mousedown = false;
      this.stage.removeAllChildren();
      this.stage.removeAllEventListeners();
      this.containers.splice(0, this.containers.length);
      this.images.splice(0, this.images.length);
      this.moved = null;
      this.stage.update();
    },
    handleFileLoad(e) {
      var image = e.result;
      let bmp = new createjs.Bitmap(image.src);
      let container = this.stage.getChildByName('source');
      bmp.id = e.item.id;
      bmp.width = image.width;
      bmp.height = image.height;
      bmp.clones = 0;
      bmp.ix = this.images.length;
      bmp.on('mousedown', this.stageMouseDown);
      bmp.on('pressup', this.stageMouseUp);
      this.images.push(bmp);
      container.addChild(bmp);
    },
    handleComplete(e) {
      var self = this;
      let container = this.containers['source'];
      let source = this.initData.source;
      var mod = 0,
        mod2 = 0,
        max = 0,
        bb = 0,
        last = 0;
      this.images.forEach(function (bmp, j) {
        if (source.isHor) {
          bb = bb < bmp.height ? bmp.height : bb;
        } else {
          bb = bb < bmp.width ? bmp.width : bb;
        }
      });
      this.images.forEach(function (bmp, j) {
        if (!bmp.parent) container.cont.addChildAt(bmp, 1);
        bmp.ix = container.indx.length;
        if (source.isHor) {
          if (j > 0) {
            mod =
              self.images[j - 1].x +
                self.images[j - 1].width +
                (source.margin && source.margin.lineH ? source.margin.lineH : 15) +
                bmp.width >
              container.cont.width
                ? 0
                : mod + 1;
            if (mod == 0) {
              mod2++;
            }
            last =
              mod == 0 && mod2 > 0
                ? (source.margin && source.margin.lineH ? source.margin.lineH : 15) +
                  bb +
                  self.images[j - 1].y -
                  (bb - self.images[j - 1].height) / 2
                : last;
          } else last = source.margin && source.margin.top ? source.margin.top : 0;
          bmp.x =
            (source.margin && source.margin.left && mod == 0 ? source.margin.left : 0) +
            ((mod > 0 ? self.images[j - 1].width + self.images[j - 1].x : 0) +
              (source.margin && source.margin.lineH ? source.margin.lineH : 15));
          bmp.y = last + (bb - bmp.height) / 2;
        } else {
          if (j > 0) {
            mod =
              self.images[j - 1].y +
                self.images[j - 1].height +
                (source.margin && source.margin.lineH ? source.margin.lineH : 15) +
                bmp.height >
              container.cont.height
                ? 0
                : mod + 1;
            if (mod == 0) {
              mod2++;
            }
            last =
              mod == 0 && mod2 > 0
                ? (source.margin && source.margin.lineH ? source.margin.lineH : 15) +
                  bb +
                  self.images[j - 1].x -
                  (bb - self.images[j - 1].width) / 2
                : last;
          } else last = source.margin && source.margin.left ? source.margin.left : 0;
          bmp.x = last + (bb - bmp.width) / 2;
          bmp.y =
            (source.margin && source.margin.top && mod == 0 ? source.margin.top : 0) +
            ((mod > 0 ? self.images[j - 1].height + self.images[j - 1].y : 0) +
              (source.margin && source.margin.lineH ? source.margin.lineH : 15));
        }
        bmp.pos = { x: bmp.x, y: bmp.y };
        bmp.newPos = { x: bmp.x, y: bmp.y };
        container.indx.push({ x: bmp.x, y: bmp.y });
      });
      container.cont.cache(0, 0, container.cont.width, container.cont.height);
      this.stage.update();
    },
    findContainer(e) {
      var cont = false,
        self = this;
      var items = this.stage.getObjectsUnderPoint(e.stageX - this.offset.x, e.stageY - this.offset.y);
      items.forEach(function (obj) {
        if (self.containers[obj.id]) {
          cont = self.containers[obj.id];
        }
      });
      return cont ? cont : this.containers['source'];
    },
    stageMouseDown(e) {
      this.resetCheckStatus();
      var ix = -1,
        cont = this.findContainer(e);
      if (cont) {
        this.images.forEach(function (bmp, i) {
          if (e.target.id == bmp.id) {
            ix = i;
          }
        });
      }
      if (ix >= 0) {
        let x = this.images[ix].parent.x;
        let y = this.images[ix].parent.y;
        if (this.initData.clone && cont.id == 'source') {
          let clone = this.images[ix].clone();
          clone.id = this.images[ix].id + 'clone' + this.images[ix].clones;
          clone.ix = ix;
          clone.on('mousedown', this.stageMouseDown);
          clone.on('pressup', this.stageMouseUp);
          this.images[ix].clones++;
          this.images.push(clone);
          ix = this.images.length - 1;
        }
        this.stage.addChildAt(this.images[ix], this.stage.children.length);
        this.moved = this.images[ix];
        this.stage.update();
        this.stage.on('stagemousemove', this.stageMouseMove);
        this.moved.x += x;
        this.moved.y += y;
        this.moved.stageX = e.stageX - this.offset.x;
        this.moved.stageY = e.stageY - this.offset.y;
        this.mousedown = true;
      } else this.moved = null;
      this.stage.update();
    },
    stageMouseMove(e) {
      if (this.mousedown) {
        this.moved.x += e.stageX - this.moved.stageX - this.offset.x;
        this.moved.y += e.stageY - this.moved.stageY - this.offset.y;
        this.moved.stageX = e.stageX - this.offset.x;
        this.moved.stageY = e.stageY - this.offset.y;
        this.moved.x = Math.round(this.moved.x);
        this.moved.y = Math.round(this.moved.y);
        var cont = this.findContainer(e);
        cont.cont.cache(0, 0, cont.cont.width, cont.cont.height);
        this.stage.update();
      }
    },
    stageMouseUp(e) {
      if (this.mousedown) {
        this.mousedown = false;
        var cont = this.findContainer(e);
        var drop = false;
        Object.keys(this.containers).forEach(function (key) {
          if (key != 'source' && key == cont.id && drop === false) drop = true;
        });
        if (drop) {
          this.moved.x -= cont.cont.x;
          this.moved.y -= cont.cont.y;
          cont.cont.addChild(this.moved);
        } else {
          if (this.initData.clone) {
            this.stage.removeChild(this.moved);
            for (let i = 0; i < this.images.length; i++) {
              if (this.images[i].id == this.moved.id) {
                this.images.splice(i, 1);
                break;
              }
            }
          } else {
            this.moved.x = this.moved.pos.x;
            this.moved.y = this.moved.pos.y;
            this.containers['source'].cont.addChild(this.moved);
          }
        }
        cont.cont.cache(0, 0, cont.cont.width, cont.cont.height);
        this.stage.update();
        this.stage.removeAllEventListeners('stagemousemove');
      }
    },
    resetGameAction() {
      this.newGame();
      this.stage = new createjs.Stage('gameCanvas');
      this.stage.mouseMoveOutside = true;
      this.stage.snapToPixelEnabled = true;
      this.setStage();
      createjs.Touch.enable(this.stage);
      // console.log(createjs.Touch.isSupported());
    },
    checkGameAction() {
      var isCorrect = true;
      return isCorrect;
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      return true;
    },
  },
  beforeDestroy() {
    this.stage.removeAllEventListeners();
  },
  computed: {
    checkGame() {
      return this.$store.getters.checkGame;
    },
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    checkGame: function (newStatus, oldStatus) {
      if (newStatus) {
        this.$store.dispatch('checkGame', this.checkGameAction());
        this.$store.commit('CHECK_GAME', false);
      }
    },
    resetGameSwitch(newStatus, oldStatus) {
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.game-container {
  display: flex;
  padding: 160px 50px 100px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

#game-container {
  margin: 0;
  width: 100%;
  height: 100%;
}

canvas {
  // border: 1px solid brown;
}
</style>
